<template>
    <div>
        <el-form ref="dataForm" :model="dataForm" inline label-width="110px" :inline="true" class="border-form">
            <el-card>
                <el-row class="set_border">
                    <el-col :span="11" class="col-set_border">
                        <el-form-item label="工程名称" class="item">
                            <el-input class="sp-input" v-model="dataForm.projectName" placeholder="请输入"
                                v-if="basicVisible" style="width: 100%;"></el-input>
                            <span class="set_span" v-if="!basicVisible">
                                {{ dataForm.projectName }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" class="col-set_border">
                        <el-form-item label="工作控制号" class="item">
                            <span class="set_span">
                                {{ dataForm.workNo }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" style="text-align: center;">
                        <div class="shift-item">Shift No. </div>
                    </el-col>
                </el-row>
                <el-row class="set_border">
                    <el-col :span="11" class="col-set_border">
                        <el-form-item label="日期" class="item">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="dataForm.logDate" type="date"
                                class="sp-input" v-if="basicVisible">
                            </el-date-picker>
                            <span class="set_span" v-if="!basicVisible">
                                {{ dataForm.logDate }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" class="col-set_border">
                        <el-form-item label="工程地点" class="item">
                            <el-input class="sp-input" v-if="basicVisible" v-model="dataForm.projectPlace"
                                placeholder=""></el-input>
                            <span class="set_span" v-if="!basicVisible">
                                {{ dataForm.projectPlace }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="vertical-middle-col">
                        <el-input class="sp-input" v-model="dataForm.logNo" placeholder="请输入"
                            v-if="basicVisible"></el-input>
                        <span class="set_span" style="text-align: center; margin-top: 15px;" v-if="!basicVisible">
                            {{ dataForm.logNo }}
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11" class="col-set_border1">
                        <el-form-item label="天气" class="item">
                            <!-- <el-input class="sp-input1" v-model="dataForm.weather" placeholder=""></el-input> -->
                            <el-input class="sp-input" v-model="dataForm.weather" placeholder="请输入" v-if="basicVisible"
                                style="width: 100%;"></el-input>
                            <span class="set_span" v-if="!basicVisible">
                                {{ dataForm.weather }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" class="col-set_border2">
                        <el-form-item label="温度、湿度" class="item">
                            <el-col v-if="basicVisible">
                                <el-col :span="11">
                                    <el-input class="sp-input" v-model="dataForm.temperature" placeholder="请输入"
                                        style="width: 100%;"></el-input>
                                </el-col>
                                <el-col :span="1" style="margin-left: 10px;margin-right: 10px;">
                                    <span>℃</span>
                                </el-col>
                                <el-col :span="10">
                                    <el-input class="sp-input" v-model="dataForm.humidity" placeholder="请输入"
                                        style="width: 100%;"></el-input>
                                </el-col>
                            </el-col>
                            <el-col v-if="!basicVisible">
                                {{ dataForm.temperature }} ℃ {{ dataForm.humidity }}
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11" class="col-set_border1">
                        <el-form-item label="监理负责人" class="item">
                            <el-input class="sp-input" v-model="dataForm.leader" placeholder="请输入" v-if="basicVisible"
                                style="width: 100%;"></el-input>
                            <span class="set_span" v-if="!basicVisible">
                                {{ dataForm.leader }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" class="col-set_border2">
                        <el-form-item label="监理工程师" class="item">
                            <el-input class="sp-input" v-model="dataForm.engineer" placeholder="请输入" v-if="basicVisible"
                                style="width: 100%;"></el-input>
                            <span class="set_span" v-if="!basicVisible">
                                {{ dataForm.engineer }}
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" style="text-align: right;margin-top: 3px;">
                        <!-- <el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()"
                            style="margin-left: 50px;">保存</el-button>
                        <el-button v-preventReClick class="rebtn" size="small" style="margin-top: 2px;"
                            @click="backPage()">返回</el-button> -->
                        <el-button class="btn" type="primary" size="small" @click="updateBasicHandle()"
                            v-if="!basicVisible">修改</el-button>
                        <el-button class="btn" type="primary" size="small" @click="saveBasicHandle()"
                            v-if="basicVisible">保存</el-button>
                        <el-button class="rebtn" size="small" @click="cancelBasicUpdateHandle()"
                            v-if="basicVisible">取消</el-button>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px;">
                    <el-row>
                        <div class="titleDiv">本日（班）工作概要</div>
                    </el-row>
                    <!-- <el-row>
                        <div class="tabItem">1.概述</div>
                    </el-row>
                    <el-row>
                        <el-row v-for="(summary, index) in dataForm.summaryList" :key="'summary' + index">
                            <el-row v-if="showSubjectName"" class=" set_sub">{{ summary.projectNo }}</el-row>
                            <draggable v-model="summary.detailList" @start="onDragStart('01', index, '')"
                                @update="onDragEnd">
                                <el-row v-for="(detail, index1) in summary.detailList" :key="'summaryDetail' + index1"
                                    class="subject_blank">
                                    <el-tooltip  placement="top"
                                        effect="light" :content="`${detail.updUserName} ${detail.updDate}`"
                                        :enterable="false">
                                        <el-col :span="24" style="cursor: pointer;">
                                            <el-col :span="1">
                                                <i class="el-icon-position"></i>
                                            </el-col>
                                            <el-col :span="23" class="set_non">
                                                <el-col :span="22" class="desc_span">
                                                    {{ detail.itemContent }}
                                                </el-col>
                                                <el-col :span="2">
                                                    <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="addOrUpdateSituation(detail.recNo, '01', summary.subjectNo)">
                                                        <i class="el-icon-edit"></i></el-button>
                                                    <el-button type="text" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="deleteWorkLogDetail(detail.recNo, '01')">
                                                        ×
                                                    </el-button>
                                                </el-col>
                                            </el-col>
                                            <el-col :span="23" style="width:90%;margin-left:170px">
                                                <div v-for="(photo, index1) in detail.photoRecords"
                                                    :key="'summaryPhoto' + index1" style="margin-top: 20px;"
                                                    v-if="detail.photoRecords != undefined && detail.photoRecords.length > 0">
                                                    <el-col :span="9">
                                                        <div style="margin:20px 20px 20px 20px ">
                                                            <el-image style="height: 250px;"
                                                                :src="photo.compressedPathUri" fit='contain'></el-image>
                                                        </div>
                                                    </el-col>
                                                </div>
                                            </el-col>
                                        </el-col>
                                    </el-tooltip>
                                </el-row>
                            </draggable>
                            <el-row>
                                <el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
                                    <el-tooltip content="添加描述" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="addOrUpdateSituation('', '01', summary.subjectNo)">
                                            <i class="el-icon-plus btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-row> -->
                    <el-row>
                        <div class="tabItem">1.项目进展</div>
                    </el-row>
                    <el-row class="item_row">
                        <draggable v-model="dataForm.progressList" @start="onDragStart('07', '', '')"
                            @update="onDragEnd">
                            <el-row v-for="(progress, index) in dataForm.progressList"
                                :key="'progress' + index">
                                <el-tooltip placement="top" effect="light"
                                    :content="(progress.updUserName || '') + ' ' + progress.updDate"
                                    :enterable="false">
                                    <el-col :span="24" style="cursor: pointer;">
                                        <el-col :span="1">
                                            <i class="el-icon-position"></i>
                                        </el-col>
                                        <el-col :span="23" class="set_non">
                                            <el-col :span="22" class="desc_span">
                                                {{ progress.itemContent }}
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                    v-if="progress.showButton == 1"
                                                    @click="addOrUpdateSituation(progress.recNo, '04')">
                                                    <i class="el-icon-edit"></i></el-button>
                                                <el-button type="text" class="desc_btn" v-if="progress.showButton == 1"
                                                    @click="deleteWorkLogDetail(progress.recNo, '04')">
                                                    ×
                                                </el-button>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="23" style="width:90%;margin-left:170px">
                                            <div v-for="(photo, index1) in progress.photoRecords"
                                                :key="'progressPhoto' + index1" style="margin-top: 20px;"
                                                v-if="progress.photoRecords != undefined && progress.photoRecords.length > 0">
                                                <el-col :span="9">
                                                    <div style="margin:20px 20px 20px 20px ">
                                                        <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                            fit='contain'></el-image>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                        <el-row>
                            <el-col :span="24" style="margin:10px 20px 10px 10px; text-align: right;">
                                <el-tooltip content="添加描述" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="addOrUpdateSituation('', '07')">
                                            <i class="el-icon-plus btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="选择描述内容" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="chooseProgressRecordHandle('07')">
                                            <i class="el-icon-search btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-row>
                    <!-- <el-row>
                        <el-row v-for="(progress, index) in dataForm.progressList" :key="'progress' + index">
                            <el-row v-if="showSubjectName"" class=" set_sub">{{ progress.projectNo }}</el-row>
                            <draggable v-model="progress.detailList" @start="onDragStart('07', index, '')"
                                @update="onDragEnd">
                                <el-row v-for="(detail, index1) in progress.detailList" :key="'progressDetail' + index1"
                                    class="subject_blank">
                                    <el-tooltip placement="top" effect="light"
                                        :content="(detail.updUserName || '') + ' ' + detail.updDate" :enterable="false">
                                        <el-col :span="24" style="cursor: pointer;">
                                            <el-col :span="1">
                                                <i class="el-icon-position"></i>
                                            </el-col>
                                            <el-col :span="23" class="set_non">
                                                <el-col :span="22" class="desc_span">
                                                    {{ detail.itemContent }}
                                                </el-col>
                                                <el-col :span="2">
                                                    <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="addOrUpdateSituation(detail.recNo, '07', progress.subjectNo)">
                                                        <i class="el-icon-edit"></i></el-button>
                                                    <el-button type="text" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="deleteWorkLogDetail(detail.recNo, '07')">
                                                        ×
                                                    </el-button>
                                                </el-col>
                                            </el-col>
                                            <el-col :span="23" style="width:90%;margin-left:170px">
                                                <div v-for="(photo, index1) in detail.photoRecords"
                                                    :key="'progressPhoto' + index1" style="margin-top: 20px;"
                                                    v-if="detail.photoRecords != undefined && detail.photoRecords.length > 0">
                                                    <el-col :span="9">
                                                        <div style="margin:20px 20px 20px 20px ">
                                                            <el-image style="height: 250px;"
                                                                :src="photo.compressedPathUri" fit='contain'></el-image>
                                                        </div>
                                                    </el-col>
                                                </div>
                                            </el-col>
                                        </el-col>
                                    </el-tooltip>
                                </el-row>
                            </draggable>
                            <el-row>
                                <el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
                                    <el-tooltip content="添加描述" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="addOrUpdateSituation('', '07', progress.subjectNo)">
                                            <i class="el-icon-plus btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="选择描述内容" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="chooseProgressRecordHandle('07', progress.subjectNo)">
                                            <i class="el-icon-search btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-row> -->
                    <el-row>
                        <div class="tabItem">2.监理工作</div>
                    </el-row>
                    <el-row>
                        <div class="second_title_div">报验及巡查情况</div>
                    </el-row>
                    <el-row class="item_row">
                        <draggable v-model="dataForm.testRecordAndInspectionList" @start="onDragStart('0203', '', '')"
                            @update="onDragEnd">
                            <el-row v-for="(testInspection, index) in dataForm.testRecordAndInspectionList"
                                :key="'testInspection' + index">
                                <el-tooltip placement="top" effect="light"
                                    :content="(testInspection.updUserName || '') + ' ' + testInspection.updDate"
                                    :enterable="false">
                                    <el-col :span="24" style="cursor: pointer;">
                                        <el-col :span="1">
                                            <i class="el-icon-position"></i>
                                        </el-col>
                                        <el-col :span="23" class="set_non">
                                            <el-col :span="22" class="desc_span">
                                                {{ testInspection.itemContent }}
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                    v-if="testInspection.showButton == 1"
                                                    @click="addOrUpdateSituation(testInspection.recNo, '04')">
                                                    <i class="el-icon-edit"></i></el-button>
                                                <el-button type="text" class="desc_btn" v-if="testInspection.showButton == 1"
                                                    @click="deleteWorkLogDetail(testInspection.recNo, '04')">
                                                    ×
                                                </el-button>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="23" style="width:90%;margin-left:170px">
                                            <div v-for="(photo, index1) in testInspection.photoRecords"
                                                :key="'testPhoto' + index1" style="margin-top: 20px;"
                                                v-if="testInspection.photoRecords != undefined && testInspection.photoRecords.length > 0">
                                                <el-col :span="9">
                                                    <div style="margin:20px 20px 20px 20px ">
                                                        <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                            fit='contain'></el-image>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                        <el-row>
                            <el-col :span="24" style="margin:10px 20px 10px 10px; text-align: right;">
                                <el-tooltip content="添加描述" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="addOrUpdateSituation('', '0203')">
                                        <i class="el-icon-plus btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="选择报验描述内容" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="chooseTestRecordHandle('0203')">
                                        <i class="el-icon-search btn-icon"></i>报验
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="选择巡查描述内容" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="chooseInspectionHandle('0203')">
                                        <i class="el-icon-search btn-icon"></i>巡查
                                    </el-button>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-row>
                    <!-- <el-row>
                        <el-row v-for="(testRecord, index) in dataForm.testRecordAndInspectionList"
                            :key="'testRecordAndInspection' + index">
                            <el-row v-if="showSubjectName"" class=" set_second_sub">{{ testRecord.projectNo }}</el-row>
                            <draggable v-model="testRecord.detailList" @start="onDragStart('0203', index, '')"
                                @update="onDragEnd">
                                <el-row v-for="(detail, index1) in testRecord.detailList"
                                    :key="'testRecordDetail' + index1" class="subject_blank">
                                    <el-tooltip placement="top" effect="light"
                                        :content="(detail.updUserName || '') + ' ' + detail.updDate" :enterable="false">
                                        <el-col :span="24" style="cursor: pointer;">
                                            <el-col :span="1">
                                                <i class="el-icon-position"></i>
                                            </el-col>
                                            <el-col :span="23" class="set_non">
                                                <el-col :span="22" class="desc_span">
                                                    {{ detail.itemContent }}
                                                </el-col>
                                                <el-col :span="2">
                                                    <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="addOrUpdateSituation(detail.recNo, '0203', testRecord.subjectNo)">
                                                        <i class="el-icon-edit"></i></el-button>
                                                    <el-button type="text" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="deleteWorkLogDetail(detail.recNo, '0203')">
                                                        ×
                                                    </el-button>
                                                </el-col>
                                            </el-col>
                                            <el-col :span="23" style="width:90%;margin-left:170px">
                                                <div v-for="(photo, index1) in detail.photoRecords"
                                                    :key="'testRecordPhoto' + index1" style="margin-top: 20px;"
                                                    v-if="detail.photoRecords != undefined && detail.photoRecords.length > 0">
                                                    <el-col :span="9">
                                                        <div style="margin:20px 20px 20px 20px ">
                                                            <el-image style="height: 250px;"
                                                                :src="photo.compressedPathUri" fit='contain'></el-image>
                                                        </div>
                                                    </el-col>
                                                </div>
                                            </el-col>
                                        </el-col>
                                    </el-tooltip>
                                </el-row>
                            </draggable>
                            <el-row>
                                <el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
                                    <el-tooltip content="添加描述" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="addOrUpdateSituation('', '0203', testRecord.subjectNo)">
                                            <i class="el-icon-plus btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="选择报验描述内容" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="chooseTestRecordHandle('0203', testRecord.subjectNo)">
                                            <i class="el-icon-search btn-icon"></i>报验
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="选择巡查描述内容" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="chooseInspectionHandle('0203', testRecord.subjectNo)">
                                            <i class="el-icon-search btn-icon"></i>巡查
                                        </el-button>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-row> -->
                    <!-- <el-row>
                        <div class="tabItem">4.巡检情况</div>
                    </el-row>
                    <el-row>
                        <el-row v-for="(inspection, index) in dataForm.inspectionList" :key="'inspection' + index">
                            <el-row v-if="showSubjectName"" class=" set_sub">{{ inspection.projectNo }}</el-row>
                            <draggable v-model="inspection.detailList" @start="onDragStart('03', index, '')"
                                @update="onDragEnd">
                                <el-row v-for="(detail, index1) in inspection.detailList"
                                    :key="'inspectionDetail' + index1" class="subject_blank">
                                    <el-tooltip  placement="top"
                                        effect="light" :content="`${detail.updUserName} ${detail.updDate}`"
                                        :enterable="false">
                                        <el-col :span="24" style="cursor: pointer;">
                                            <el-col :span="1">
                                                <i class="el-icon-position"></i>
                                            </el-col>
                                            <el-col :span="23" class="set_non">
                                                <el-col :span="22" class="desc_span">
                                                    {{ detail.itemContent }}
                                                </el-col>
                                                <el-col :span="2">
                                                    <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="addOrUpdateSituation(detail.recNo, '03', inspection.subjectNo)">
                                                        <i class="el-icon-edit"></i></el-button>
                                                    <el-button type="text" class="desc_btn"
                                                        v-if="detail.showButton == 1"
                                                        @click="deleteWorkLogDetail(detail.recNo, '03')">
                                                        ×
                                                    </el-button>
                                                </el-col>
                                            </el-col>
                                            <el-col :span="23" style="width:90%;margin-left:170px">
                                                <div v-for="(photo, index1) in detail.photoRecords"
                                                    :key="'inspectionPhoto' + index1" style="margin-top: 20px;"
                                                    v-if="detail.photoRecords != undefined && detail.photoRecords.length > 0">
                                                    <el-col :span="9">
                                                        <div style="margin:20px 20px 20px 20px ">
                                                            <el-image style="height: 250px;"
                                                                :src="photo.compressedPathUri" fit='contain'></el-image>
                                                        </div>
                                                    </el-col>
                                                </div>
                                            </el-col>
                                        </el-col>
                                    </el-tooltip>
                                </el-row>
                            </draggable>
                            <el-row>
                                <el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
                                    <el-tooltip content="添加描述" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="addOrUpdateSituation('', '03', inspection.subjectNo)">
                                            <i class="el-icon-plus btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="选择描述内容" placement="top" effect="light">
                                        <el-button class="week_btn" type="primary" size="small"
                                            @click="chooseInspectionHandle('03', inspection.subjectNo)">
                                            <i class="el-icon-search btn-icon"></i>
                                        </el-button>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-row> -->
                    <el-row>
                        <div class="second_title_div">会议情况</div>
                    </el-row>
                    <el-row class="item_row">
                        <draggable v-model="dataForm.meetList" @start="onDragStart('04', '', '')" @update="onDragEnd">
                            <el-row v-for="(meet, index) in dataForm.meetList" :key="'meet' + index">
                                <el-tooltip placement="top" effect="light"
                                    :content="(meet.updUserName || '') + ' ' + meet.updDate" :enterable="false">
                                    <el-col :span="24" style="cursor: pointer;">
                                        <el-col :span="1">
                                            <i class="el-icon-position"></i>
                                        </el-col>
                                        <el-col :span="23" class="set_non">
                                            <el-col :span="22" class="desc_span">
                                                {{ meet.itemContent }}
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                    v-if="meet.showButton == 1"
                                                    @click="addOrUpdateSituation(meet.recNo, '04')">
                                                    <i class="el-icon-edit"></i></el-button>
                                                <el-button type="text" class="desc_btn" v-if="meet.showButton == 1"
                                                    @click="deleteWorkLogDetail(meet.recNo, '04')">
                                                    ×
                                                </el-button>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="23" style="width:90%;margin-left:170px">
                                            <div v-for="(photo, index1) in meet.photoRecords"
                                                :key="'meetPhoto' + index1" style="margin-top: 20px;"
                                                v-if="meet.photoRecords != undefined && meet.photoRecords.length > 0">
                                                <el-col :span="9">
                                                    <div style="margin:20px 20px 20px 20px ">
                                                        <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                            fit='contain'></el-image>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                        <el-row>
                            <el-col :span="24" style="margin:10px 20px 10px 10px; text-align: right;">
                                <el-tooltip content="添加描述 " placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="addOrUpdateSituation('', '04')">
                                        <i class="el-icon-plus btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="选择会议" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="selectMeetingHandle('04')">
                                        <i class="el-icon-search btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-row>
                    <el-row>
                        <div class="second_title_div">文件审查情况</div>
                    </el-row>
                    <el-row class="item_row">
                        <draggable v-model="dataForm.fileRecordList" @start="onDragStart('08', '', '')"
                            @update="onDragEnd">
                            <el-row v-for="(fileRecord, index) in dataForm.fileRecordList" :key="'fileRecord' + index">
                                <el-tooltip placement="top" effect="light"
                                    :content="(fileRecord.updUserName || '') + ' ' + fileRecord.updDate"
                                    :enterable="false">
                                    <el-col :span="24" style="cursor: pointer;">
                                        <el-col :span="1">
                                            <i class="el-icon-position"></i>
                                        </el-col>
                                        <el-col :span="23" class="set_non">
                                            <el-col :span="22" class="desc_span">
                                                {{ fileRecord.itemContent }}
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                    v-if="fileRecord.showButton == 1"
                                                    @click="addOrUpdateSituation(fileRecord.recNo, '08')">
                                                    <i class="el-icon-edit"></i></el-button>
                                                <el-button type="text" class="desc_btn"
                                                    v-if="fileRecord.showButton == 1"
                                                    @click="deleteWorkLogDetail(fileRecord.recNo, '08')">
                                                    ×
                                                </el-button>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="23" style="width:90%;margin-left:170px">
                                            <div v-for="(photo, index1) in fileRecord.photoRecords"
                                                :key="'fileRecordPhoto' + index1" style="margin-top: 20px;"
                                                v-if="fileRecord.photoRecords != undefined && fileRecord.photoRecords.length > 0">
                                                <el-col :span="9">
                                                    <div style="margin:20px 20px 20px 20px ">
                                                        <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                            fit='contain'></el-image>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                        <el-row>
                            <el-col :span="24" style="margin:10px 20px 10px 10px; text-align: right;">
                                <el-tooltip content="添加描述 " placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="addOrUpdateSituation('', '08')">
                                        <i class="el-icon-plus btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                                <!-- <el-tooltip content="选择文件审查" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="selectFileRecordHandle('08')">
                                        <i class="el-icon-search btn-icon"></i>
                                    </el-button>
                                </el-tooltip> -->
                            </el-col>
                        </el-row>
                    </el-row>
                    <!-- <el-row>
                        <div class="second_title_div"></div>
                    </el-row>
                    <el-row class="item_row">
                        <draggable v-model="dataForm.coordinateRecordList" @start="onDragStart('05', '', '')"
                            @update="onDragEnd">
                            <el-row v-for="(coordinateRecord, index) in dataForm.coordinateRecordList"
                                :key="'coordinateRecord' + index">
                                <el-tooltip placement="top" effect="light"
                                    :content="`${coordinateRecord.updUserName} ${coordinateRecord.updDate}`"
                                    :enterable="false">
                                    <el-col :span="24" style="cursor: pointer;">
                                        <el-col :span="1">
                                            <i class="el-icon-position"></i>
                                        </el-col>
                                        <el-col :span="23" class="set_non">
                                            <el-col :span="22" class="desc_span">
                                                {{ coordinateRecord.itemContent }}
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                    v-if="coordinateRecord.showButton == 1"
                                                    @click="addOrUpdateSituation(coordinateRecord.recNo, '05')">
                                                    <i class="el-icon-edit"></i></el-button>
                                                <el-button type="text" class="desc_btn"
                                                    v-if="coordinateRecord.showButton == 1"
                                                    @click="deleteWorkLogDetail(coordinateRecord.recNo, '05')">
                                                    ×
                                                </el-button>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="23" style="width:90%;margin-left:170px">
                                            <div v-for="(photo, index1) in coordinateRecord.photoRecords"
                                                :key="'coordinateRecordPhoto' + index1" style="margin-top: 20px;"
                                                v-if="coordinateRecord.photoRecords != undefined && coordinateRecord.photoRecords.length > 0">
                                                <el-col :span="9">
                                                    <div style="margin:20px 20px 20px 20px ">
                                                        <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                            fit='contain'></el-image>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                        <el-row>
                            <el-col :span="24" style="margin:10px 20px 10px 10px; text-align: right;">
                                <el-tooltip content="添加描述 " placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="addOrUpdateSituation('', '05')">
                                        <i class="el-icon-plus btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="选择协调记录" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="selectCoordinateHandle('05')">
                                        <i class="el-icon-search btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-row> -->
                    <el-row>
                        <div class="second_title_div">其他</div>
                    </el-row>
                    <el-row class="item_row">
                        <draggable v-model="dataForm.otherList" @start="onDragStart('06', '', '')" @update="onDragEnd">
                            <el-row v-for="(other, index) in dataForm.otherList" :key="'other' + index">
                                <el-tooltip placement="top" effect="light"
                                    :content="(other.updUserName || '') + ' ' + other.updDate" :enterable="false">
                                    <el-col :span="24" style="cursor: pointer;">
                                        <el-col :span="1">
                                            <i class="el-icon-position"></i>
                                        </el-col>
                                        <el-col :span="23" class="set_non">
                                            <el-col :span="22" class="desc_span">
                                                {{ other.itemContent }}
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                    v-if="other.showButton == 1"
                                                    @click="addOrUpdateSituation(other.recNo, '06')">
                                                    <i class="el-icon-edit"></i></el-button>
                                                <el-button type="text" class="desc_btn" v-if="other.showButton == 1"
                                                    @click="deleteWorkLogDetail(other.recNo, '05')">
                                                    ×
                                                </el-button>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="23" style="width:90%;margin-left:170px">
                                            <div v-for="(photo, index1) in other.photoRecords"
                                                :key="'otherPhoto' + index1" style="margin-top: 20px;"
                                                v-if="other.photoRecords != undefined && other.photoRecords.length > 0">
                                                <el-col :span="9">
                                                    <div style="margin:20px 20px 20px 20px ">
                                                        <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                            fit='contain'></el-image>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                        <el-row>
                            <el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
                                <el-tooltip content="添加描述 " placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="addOrUpdateSituation('', '06')">
                                        <i class="el-icon-plus btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="选择协调记录" placement="top" effect="light">
                                    <el-button class="week_btn" type="primary" size="small"
                                        @click="selectCoordinateHandle('06')">
                                        <i class="el-icon-search btn-icon"></i>
                                    </el-button>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-row>
                </el-row>
                <el-row>
                    <div class="titleDiv">本日（班）签发文件清单</div>
                </el-row>
                <el-row>
                    <draggable v-model="dataForm.fileList" @start="onDragStart('10', '', '')" @update="onDragEnd">
                        <el-row v-for="(file, index) in dataForm.fileList" :key="'file' + index">
                            <el-tooltip placement="top" effect="light"
                                :content="(file.updUserName || '') + ' ' + file.updDate" :enterable="false">
                                <el-col :span="24" style="cursor: pointer;">
                                    <el-col :span="1">
                                        <i class="el-icon-position"></i>
                                    </el-col>
                                    <el-col :span="23" class="set_non">
                                        <el-col :span="22" class="desc_span">
                                            {{ file.itemContent }}
                                        </el-col>
                                        <el-col :span="1">
                                            <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                v-if="file.showButton == 1"
                                                @click="addOrUpdateSituation(file.recNo, '10')">
                                                <i class="el-icon-edit"></i></el-button>
                                            <el-button type="text" class="desc_btn" v-if="file.showButton == 1"
                                                @click="deleteWorkLogDetail(file.recNo, '10')">
                                                ×
                                            </el-button>
                                        </el-col>
                                    </el-col>
                                    <el-col :span="23" style="width:90%;margin-left:170px">
                                        <div v-for="(photo, index1) in file.photoRecords" :key="'filePhoto' + index1"
                                            style="margin-top: 20px;"
                                            v-if="file.photoRecords != undefined && file.photoRecords.length > 0">
                                            <el-col :span="9">
                                                <div style="margin:20px 20px 20px 20px ">
                                                    <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                        fit='contain'></el-image>
                                                </div>
                                            </el-col>
                                        </div>
                                    </el-col>
                                </el-col>
                            </el-tooltip>
                        </el-row>
                    </draggable>
                    <el-row>
                        <el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
                            <el-tooltip content="添加描述 " placement="top" effect="light">
                                <el-button class="week_btn" type="primary" size="small"
                                    @click="addOrUpdateSituation('', '10')">
                                    <i class="el-icon-plus btn-icon"></i>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip content="选择联系单" placement="top" effect="light">
                                <el-button class="week_btn" type="primary" size="small"
                                    @click="chooseContactHandle('10', '1')">
                                    <i class="el-icon-search btn-icon"></i>联系单
                                </el-button>
                            </el-tooltip>
                            <el-tooltip content="选择通知单" placement="top" effect="light">
                                <el-button class="week_btn" type="primary" size="small"
                                    @click="chooseContactHandle('10', '2')">
                                    <i class="el-icon-search btn-icon"></i>通知单
                                </el-button>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                </el-row>
                <el-row>
                    <div class="titleDiv">本日（班）备忘</div>
                </el-row>
                <el-row>
                    <draggable v-model="dataForm.noteList" @start="onDragStart('20', '', '')" @update="onDragEnd">
                        <el-row v-for="(note, index) in dataForm.noteList" :key="'note' + index">
                            <el-tooltip placement="top" effect="light"
                                :content="(note.updUserName || '') + ' ' + note.updDate" :enterable="false">
                                <el-col :span="24" style="cursor: pointer;">
                                    <el-col :span="1">
                                        <i class="el-icon-position"></i>
                                    </el-col>
                                    <el-col :span="23" class="set_non">
                                        <el-col :span="22" class="desc_span">
                                            {{ note.itemContent }}
                                        </el-col>
                                        <el-col :span="1">
                                            <el-button type="text" style="margin-right: 10px;" class="desc_btn"
                                                v-if="note.showButton == 1"
                                                @click="addOrUpdateSituation(note.recNo, '20')">
                                                <i class="el-icon-edit"></i></el-button>
                                            <el-button type="text" class="desc_btn" v-if="note.showButton == 1"
                                                @click="deleteWorkLogDetail(note.recNo, '20')">
                                                ×
                                            </el-button>
                                        </el-col>
                                    </el-col>
                                    <el-col :span="23" style="width:90%;margin-left:170px">
                                        <div v-for="(photo, index1) in note.photoRecords" :key="'notePhoto' + index1"
                                            style="margin-top: 20px;"
                                            v-if="note.photoRecords != undefined && note.photoRecords.length > 0">
                                            <el-col :span="9">
                                                <div style="margin:20px 20px 20px 20px ">
                                                    <el-image style="height: 250px;" :src="photo.compressedPathUri"
                                                        fit='contain'></el-image>
                                                </div>
                                            </el-col>
                                        </div>
                                    </el-col>
                                </el-col>
                            </el-tooltip>
                        </el-row>
                    </draggable>
                    <el-row>
                        <el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
                            <el-tooltip content="添加描述 " placement="top" effect="light">
                                <el-button class="week_btn" type="primary" size="small"
                                    @click="addOrUpdateSituation('', '20')">
                                    <i class="el-icon-plus btn-icon"></i>
                                </el-button>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                </el-row>
                <el-row>
                    <div class="titleDiv">工作附图</div>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-button v-preventReClick type="text" size="small"
                            style="background-color: rgb(3, 73, 138);color: aliceblue;width: 110px;margin-top: 10px; margin-bottom: 20px;"
                            @click="selectPhoto()">+ 添加照片</el-button>
                    </el-col>
                    <!-- <el-col :span="12" style="margin-top: 20px;">
                        <span style="color: coral;">默认把当天的照片都提取出来，包括质量和进度</span>
                    </el-col> -->
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="card" v-for="(photo, index) in dataForm.photoList" :key="index"
                                :style="{ order: photo.sort }" @dragstart="dragStart(index)" @dragover.prevent
                                @drop="drop(index)" @dragend="dragEnd" draggable="true">
                                <el-col :span="4">
                                    <el-card :body-style="{ padding: '0px' }"
                                        style="margin-bottom: 10px;margin-right: 15px;height: 285px;">
                                        <el-image :src="photo.compressedPathUri" fit="scale-down"
                                            class="image"></el-image>
                                        <div style="padding: 2px 10px;font-size: 13px;">
                                            <div class="t-column-ellipsis">
                                                <span>{{ photo.photoContent }}</span>
                                            </div>
                                            <div class="bottom clearfix">
                                                <el-button type="text" class="button"
                                                    @click="deleteWorkLogPhoto(photo.recNo)">删除</el-button>
                                                <el-button type="text" class="button" style="margin-right: 10px;"
                                                    @click="updateImgContent(photo.recNo, photo.photoContent)">修改</el-button>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                            </div>
                        </el-col>
                    </el-row>
                </el-row>
            </el-card>
        </el-form>
        <!-- 质量进度照片内容修改 -->
        <el-dialog title="修改描述" :visible.sync="updateImgContentVisable" width="30%" :close-on-click-modal="false">
            <el-form>
                <el-row>
                    <el-form-item label="">
                        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="updatePhotoContent"
                            placeholder="请填写" style="width:400px"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button v-preventReClick class="btn" type="primary" size="small" @click="saveImgContent">确
                    定</el-button>
                <el-button v-preventReClick class="rebtn" size="small" @click="updateImgContentVisable = false">取
                    消</el-button>
            </span>
        </el-dialog>

        <photo-select v-if="photoSelectVisible" ref="photoSelect"
            @refreshDataList="getWorkLogSituationList"></photo-select>
        <add-or-update-situation v-if="addOrUpdateSituationVisible" ref="addOrUpdateSituation"
            @refreshDataList="getWorkLogSituationList"></add-or-update-situation>
        <choose-progress-record v-if="chooseProgressRecordVisible" ref="chooseProgressRecord"
            @refreshDataList="getWorkLogSituationList"></choose-progress-record>
        <choose-test-record v-if="chooseTestRecordVisible" ref="chooseTestRecord"
            @refreshDataList="getWorkLogSituationList"></choose-test-record>
        <choose-inspection v-if="chooseInspectionVisible" ref="chooseInspection"
            @refreshDataList="getWorkLogSituationList"></choose-inspection>
        <choose-meeting v-if="chooseMeetingVisible" ref="chooseMeeting"
            @refreshDataList="getWorkLogSituationList"></choose-meeting>
        <select-coordinate v-if="selectCoordinateVisible" ref="selectCoordinate"
            @refreshDataList="getWorkLogSituationList"></select-coordinate>
        <contact-select v-if="selectContactVisible" ref="contactSelect"
            @refreshDataList="getWorkLogSituationList"></contact-select>
    </div>
</template>

<script>
import $common from "@/utils/common.js"
import PhotoSelect from './workloginfo-photo-select.vue'
import AddOrUpdateSituation from './add-or-update-situation.vue'
import ContactSelect from './contact-select.vue'
import draggable from 'vuedraggable';
import ChooseProgressRecord from './choose-progress-record.vue'
import ChooseTestRecord from './choose-test-record.vue'
import ChooseInspection from './choose-inspection.vue'
import ChooseMeeting from './choose-meeting.vue'
import SelectCoordinate from './select-coordinate.vue'
export default {
    name: "workloginfo-preset",
    data() {
        return {
            basicVisible: false,
            photoSelectVisible: false,
            updateImgContentVisable: false,
            addOrUpdateSituationVisible: false,
            chooseProgressRecordVisible: false,
            chooseInspectionVisible: false,
            chooseMeetingVisible: false,
            chooseTestRecordVisible: false,
            selectCoordinateVisible: false,
            selectContactVisible: false,
            chooseContactVisible: false,
            contactSelectVisible: false,
            showSubjectName: false,
            updatePhotoRecNo: '',
            photoViewCol: 6,
            updatePhotoContent: '',
            dataForm: {
                workNo: $common.getItem("workNo"),
                logDate: '',
                logNo: '',
                filePath: '',
                workLogKind: '',
                fileRecordList: [],
                noteList: [],
                otherList: [],
                photoList: [],
                summaryList: [],
                fileList: [],
                testRecordList: [],
                inspectionList: [],
                meetList: [],
                coordinateRecordList: [],
                progressList: [],
            },
            subjectList: [],
            updateItemNo: '',
            updateIndex: '',
            updateIndex1: ''
        }
    },
    components: {
        PhotoSelect,
        AddOrUpdateSituation,
        draggable,
        ContactSelect,
        ChooseProgressRecord,
        ChooseTestRecord,
        ChooseInspection,
        ChooseMeeting,
        SelectCoordinate
    },
    mounted() {
        this.dataForm.recNo = this.$route.query.recNo
        this.activeIndex = 'jobSummary'
        this.getSubjectDropDown()
        this.getDetail()
    },
    methods: {
        backPage() {
            this.$router.go(-1);
        },
        /* 照片拖拽 begin */
        cardRows(photoList) {
            const rows = [];
            if (photoList != null) {
                for (let i = 0; i < photoList.length; i += this.photoViewCol) {
                    rows.push(photoList.slice(i, i + this.photoViewCol));
                }
            }
            return rows;
        },
        updateImgContent(recNo, photoContent) {
            this.updateImgContentVisable = true;
            this.updatePhotoContent = photoContent;
            this.updatePhotoRecNo = recNo;
        },
        saveImgContent() {
            // 直接更新到db
            let _url = "/business/worklogphotoinfo/updatePhotoContent";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData({
                    recNo: this.updatePhotoRecNo,
                    photoContent: this.updatePhotoContent
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.updateImgContentVisable = false
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.getWorkLogSituationList();
                }
            });
        },
        dragStart(index) {
            this.draggedItem = { index: index };
        },
        drop(index) {
            const x = this.draggedItem.index
            const y = index
            let photoList = this.dataForm.photoList
            if (x == y) {
                return
            } else if (x < y) {
                const item = photoList.splice(x, 1)[0];
                photoList.splice(y, 0, item);
            } else {
                const item = photoList.splice(x, 1)[0];
                photoList.splice(y, 0, item);
            }
            if (photoList != undefined && photoList.length > 1) {
                // 直接保存至db
                let url = "/business/worklogphotoinfo/sort"
                this.$http({
                    url: this.$store.state.httpUrl + url,
                    method: "POST",
                    data: this.$http.adornData({
                        records: photoList,
                    }),
                }).then(({ data }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getWorkLogSituationList();
                            }
                        })
                    }
                });
            }
        },
        dragEnd() {
            this.draggedItem = {};

        },
        deleteWorkLogPhoto(recNo) {
            this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: this.$store.state.httpUrl + "/business/worklogphotoinfo/delete/" + recNo,
                    method: "post",
                    data: {},
                }).then(({ data }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getWorkLogSituationList()
                            }
                        })
                    }
                });
            })

        },
        getCurrentTime() {
            //获取当前时间并打印
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
            let dd = (new Date().getDate()) < 10 ? '0' + (new Date().getDate()) : (new Date().getDate());
            // let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            return yy + '-' + mm + '-' + dd;
        },
        handleTabClick(tab) {
            this.activeIndex = tab.name
        },
        updateBasicHandle() {
            this.basicVisible = true;
        },
        cancelBasicUpdateHandle() {
            this.basicVisible = false;
            this.getDetail()
        },
        getSubjectDropDown() {
            this.$http({
                url: this.$store.state.httpUrl + "/common/getWorkLogSubjectList/" + $common.getItem("workNo"),
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.subjectList = data.body;
                    this.showSubjectName = false;
                    if (this.subjectList != null && this.subjectList != undefined && this.subjectList.length > 1) {
                        this.showSubjectName = true;
                    }
                }
            });
        },
        saveBasicHandle() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/workloginfo/update",
                method: 'post',
                data: this.$http.adornData({
                    recNo: this.dataForm.recNo,
                    workNo: $common.getItem("workNo"),
                    projectName: this.dataForm.projectName,
                    logDate: this.dataForm.logDate,
                    projectPlace: this.dataForm.projectPlace,
                    logNo: this.dataForm.logNo,
                    weather: this.dataForm.weather,
                    temperature: this.dataForm.temperature,
                    humidity: this.dataForm.humidity,
                    leader: this.dataForm.leader,
                    engineer: this.dataForm.engineer,
                })
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.getDetail()
                    this.basicVisible = false;
                }
            })
        },
        addOrUpdateSituation(recNo, itemNo, subjectNo) {
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo, subjectNo);
            this.addOrUpdateSituationVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateSituation.init(this.dataForm.recNo, recNo, sort + 1, itemNo, subjectNo)
            })
        },
        getMaxSort(itemNo, subjectNo) {
            // 计算最大排序值
            let sort = 0;
            if (itemNo === '01' && this.dataForm.summaryList != undefined && this.dataForm.summaryList.length > 0) {
                // for (var i = 0; i < this.dataForm.summaryList.length; i++) {
                //     let summary = this.dataForm.summaryList[i];
                //     if (summary.subjectNo === subjectNo) {
                //         let detailList = summary.detailList;
                //         for (var j = 0; j < detailList.length; j++) {
                //             if (detailList[j].sort > sort) {
                //                 sort = detailList[j].sort
                //             }
                //         }
                //     }
                // }
                 for (var i = 0; i < this.dataForm.summaryList.length; i++) {
                    if (this.dataForm.summaryList[i].sort > sort) {
                        sort = this.dataForm.summaryList[i].sort
                    }
                }
            } else if (itemNo === '0203' && this.dataForm.testRecordAndInspectionList != undefined && this.dataForm.testRecordAndInspectionList.length > 0) {
                for (var i = 0; i < this.dataForm.testRecordAndInspectionList.length; i++) {
                    if (this.dataForm.testRecordAndInspectionList[i].sort > sort) {
                        sort = this.dataForm.testRecordAndInspectionList[i].sort
                    }
                }
            } else if (itemNo === '04' && this.dataForm.meetList != undefined && this.dataForm.meetList.length > 0) {
                for (var i = 0; i < this.dataForm.meetList.length; i++) {
                    if (this.dataForm.meetList[i].sort > sort) {
                        sort = this.dataForm.meetList[i].sort
                    }
                }
            } else if (itemNo === '05' && this.dataForm.coordinateRecordList != undefined && this.dataForm.coordinateRecordList.length > 0) {
                for (var i = 0; i < this.dataForm.coordinateRecordList.length; i++) {
                    if (this.dataForm.coordinateRecordList[i].sort > sort) {
                        sort = this.dataForm.coordinateRecordList[i].sort
                    }
                }
            } else if (itemNo === '06' && this.dataForm.otherList != undefined && this.dataForm.otherList.length > 0) {
                for (var i = 0; i < this.dataForm.otherList.length; i++) {
                    if (this.dataForm.otherList[i].sort > sort) {
                        sort = this.dataForm.otherList[i].sort
                    }
                }
            } else if (itemNo === '07' && this.dataForm.progressList != undefined && this.dataForm.progressList.length > 0) {
                // for (var i = 0; i < this.dataForm.progressList.length; i++) {
                //     let progress = this.dataForm.progressList[i];
                //     if (progress.subjectNo === subjectNo) {
                //         let detailList = progress.detailList;
                //         for (var j = 0; j < detailList.length; j++) {
                //             if (detailList[j].sort > sort) {
                //                 sort = detailList[j].sort
                //             }
                //         }
                //     }
                // }
                for (var i = 0; i < this.dataForm.progressList.length; i++) {
                    if (this.dataForm.progressList[i].sort > sort) {
                        sort = this.dataForm.progressList[i].sort
                    }
                }
            } else if (itemNo === '08' && this.dataForm.fileRecordList != undefined && this.dataForm.fileRecordList.length > 0) {
                for (var i = 0; i < this.dataForm.fileRecordList.length; i++) {
                    if (this.dataForm.fileRecordList[i].sort > sort) {
                        sort = this.dataForm.fileRecordList[i].sort
                    }
                }
            } else if (itemNo === '10' && this.dataForm.fileList != undefined && this.dataForm.fileList.length > 0) {
                for (var i = 0; i < this.dataForm.fileList.length; i++) {
                    if (this.dataForm.fileList[i].sort > sort) {
                        sort = this.dataForm.fileList[i].sort
                    }
                }
            } else if (itemNo === '20' && this.dataForm.noteList != undefined && this.dataForm.noteList.length > 0) {
                for (var i = 0; i < this.dataForm.noteList.length; i++) {
                    if (this.dataForm.noteList[i].sort > sort) {
                        sort = this.dataForm.noteList[i].sort
                    }
                }
            }
            return sort;
        },
        onDragStart(itemNo, index, index1) {
            this.updateItemNo = itemNo;
            this.updateIndex = index;
            this.updateIndex1 = index1;
        },
        onDragEnd(event) {
            event.preventDefault();
            // 拖拽结束后的处理逻辑
            let records = [];
            if (this.updateItemNo == '01') {
                // 01 概述
                records = this.dataForm.summaryList[this.updateIndex].detailList
            } else if (this.updateItemNo == '0203') {
                // 0203 报验和巡检情况
                // records = this.dataForm.testRecordAndInspectionList[this.updateIndex].detailList
                records = this.dataForm.testRecordAndInspectionList
                // } else if (this.updateItemNo == '02') {
                //     // 02 报验
                //     records = this.dataForm.testRecordList[this.updateIndex].detailList
                // } else if (this.updateItemNo == '03') {
                //     // 03 巡检
                //     records = this.dataForm.inspectionList[this.updateIndex].detailList
            } else if (this.updateItemNo == '04') {
                // 04 会议
                records = this.dataForm.meetList
            } else if (this.updateItemNo == '05') {
                // 05 协调
                records = this.dataForm.coordinateRecordList
            } else if (this.updateItemNo == '06') {
                // 06 其他
                records = this.dataForm.otherList
            } else if (this.updateItemNo == '07') {
                // 07 进度详情
                // records = this.dataForm.progressList[this.updateIndex].detailList
                records = this.dataForm.progressList
            } else if (this.updateItemNo == '08') {
                // 08 文件审查情况
                records = this.dataForm.fileRecordList
            } else if (this.updateItemNo == '10') {
                // 10 文件记录
                records = this.dataForm.fileList
            } else if (this.updateItemNo == '20') {
                // 20 本日（班）备忘
                records = this.dataForm.noteList
            }
            this.$http({
                url: this.$store.state.httpUrl + "/business/worklogdetailinfo/sort",
                method: "post",
                data: this.$http.adornData({
                    itemNo: this.updateItemNo,
                    workLogRecNo: this.dataForm.recNo,
                    records: records
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.updateItemNo = ''
                            this.getWorkLogSituationList();
                        }
                    });
                }
            });
        },
        getWorkLogSituationList() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/workloginfo/getWorkLogSituationList/" + this.dataForm.recNo,
                method: "get",
                params: {
                },
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm.summaryList = data.body.summaryList
                    // this.dataForm.testRecordList = data.body.testRecordList
                    // this.dataForm.inspectionList = data.body.inspectionList
                    this.dataForm.testRecordAndInspectionList = data.body.testRecordAndInspectionList
                    this.dataForm.meetList = data.body.meetList
                    this.dataForm.progressList = data.body.progressList
                    this.dataForm.coordinateRecordList = data.body.coordinateRecordList
                    this.dataForm.otherList = data.body.otherList
                    this.dataForm.fileList = data.body.fileList
                    this.dataForm.fileRecordList = data.body.fileRecordList
                    this.dataForm.noteList = data.body.noteList
                    this.dataForm.photoList = data.body.photoList
                }
            });
        },
        deleteWorkLogDetail(recNo, itemNo) {
            this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: this.$store.state.httpUrl + "/business/worklogdetailinfo/delete/" + recNo,
                    method: "post",
                    data: {},
                }).then(({ data }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getWorkLogSituationList()
                            }
                        })
                    }
                });
            })
        },
        chooseProgressRecordHandle(itemNo, subjectNo) {
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo, subjectNo);
            this.chooseProgressRecordVisible = true;
            this.$nextTick(() => {
                this.$refs.chooseProgressRecord.init(this.dataForm.recNo, sort + 1, itemNo, subjectNo, this.dataForm.logDate)
            })
        },
        chooseTestRecordHandle(itemNo, subjectNo) {
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo, subjectNo);
            this.chooseTestRecordVisible = true;
            this.$nextTick(() => {
                this.$refs.chooseTestRecord.init(this.dataForm.recNo, sort + 1, itemNo, subjectNo, this.dataForm.logDate)
            })
        },
        chooseInspectionHandle(itemNo, subjectNo) {
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo, subjectNo);
            this.chooseInspectionVisible = true;
            this.$nextTick(() => {
                this.$refs.chooseInspection.init(this.dataForm.recNo, sort + 1, itemNo, subjectNo, this.dataForm.logDate)
            })
        },
        selectMeetingHandle(itemNo) {
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo);
            // 获取会议情况来源ids
            let meetIds = ''
            // let meetList = this.dataForm.meetList
            // if (meetList != undefined && meetList.length > 0) {
            // 	for (var i = 0; i < meetList.length; i++) {
            // 		if (meetList[i].sourceType != null && meetList[i].sourceType == '3' && meetList[i].sourceId != null) {
            // 			meetIds = meetIds + meetList[i].sourceId
            // 			if (i < meetList.length - 1) {
            // 				meetIds = meetIds + ','
            // 			}
            // 		}
            // 	}
            // }
            this.chooseMeetingVisible = true;
            this.$nextTick(() => {
                this.$refs.chooseMeeting.init(this.dataForm.recNo, sort + 1, itemNo, this.dataForm.logDate, meetIds)
            })
        },
        selectCoordinateHandle(itemNo) {
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo);
            let coordinateNos = []
            // let coordinateRecordList = this.dataForm.coordinateRecordList
            // if (coordinateRecordList != undefined && coordinateRecordList.length > 0) {
            //     for (var i = 0; i < coordinateRecordList.length; i++) {
            //         if (coordinateRecordList[i].sourceType != null && coordinateRecordList[i].sourceType == '2' && coordinateRecordList[i].sourceId != null) {
            //             coordinateNos = coordinateNos + coordinateRecordList[i].sourceId
            //             if (i < coordinateRecordList.length - 1) {
            //                 coordinateNos = coordinateNos + ','
            //             }
            //         }
            //     }
            // }
            this.selectCoordinateVisible = true
            this.$nextTick(() => {
                this.$refs.selectCoordinate.init(this.dataForm.recNo, sort + 1, itemNo, this.dataForm.logDate, coordinateNos)
            })
        },
        chooseContactHandle(itemNo, fileKind) {
            this.selectContactVisible = true
            // 获取ids
            let recIds = ''
            let fileList = this.dataForm.fileList
            // if (fileList != undefined && fileList.length > 0) {
            //     for (var i = 0; i < fileList.length; i++) {
            //         if ((fileList[i].sourceType === '7' && fileKind == '2') || fileList[i].sourceType === '6' && fileKind == '1') {
            //             recIds = recIds + fileList[i].sourceId
            //             if (i < fileList.length - 1) {
            //                 recIds = recIds + ','
            //             }
            //         }
            //     }
            // }
            // 计算最大排序值
            let sort = this.getMaxSort(itemNo);
            this.$nextTick(() => {
                this.$refs.contactSelect.init(this.dataForm.recNo, sort + 1, itemNo, fileKind, this.dataForm.logDate, recIds)
            })
        },
        selectPhoto() {
            // if (this.dataForm.logDate == undefined || this.dataForm.logDate == null || this.dataForm.logDate === '') {
            //     this.$message.error("请设置日期");
            //     return;
            // }
            // 计算最大排序值
            let sort = 0;
            let photoIds = ''
            if (this.dataForm.photoList != undefined && this.dataForm.photoList.length > 0) {
                for (var i = 0; i < this.dataForm.photoList.length; i++) {
                    let photo = this.dataForm.photoList[i];
                    // photoIds = photoIds + photo.sourceId
                    // if (i < this.dataForm.photoList.length - 1) {
                    //     photoIds = photoIds + ','
                    // }
                    if (photo.sort > sort) {
                        sort = photo.sort
                    }
                }
            }

            this.photoSelectVisible = true
            this.$nextTick(() => {
                this.$refs.photoSelect.init(this.dataForm.recNo, sort + 1, this.dataForm.logDate, photoIds)
            })
        },
        // margeSelectItems(items) {
        //     this.photoSelectVisible = false;
        //     // 循环处理选择的图片
        //     for (var selectItem of items) {
        //         let exist = false;
        //         for (var record of this.dataForm.photoList) {
        //             if (selectItem.photoPathUri === record.photoFileUri) {
        //                 exist = true;
        //                 break;
        //             }
        //         }
        //         if (!exist) {
        //             let photo = {
        //                 workLogRecNo: this.dataForm.recNo,
        //                 photoContent: selectItem.photoContent,
        //                 photoFilePath: selectItem.photoFilePath,
        //                 photoFileUri: selectItem.photoPathUri,
        //             }
        //             this.dataForm.photoList.push(photo)
        //         }
        //     }
        // },
        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/workloginfo/info/" + this.dataForm.recNo,
                method: "get",
                params: {},
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body;
                }
            });
        },
        getPresetInfo() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/worklogpreset/presetInfo/" + $common.getItem("workNo"),
                method: "get"
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm.workNo = $common.getItem("workNo")
                    this.dataForm.recNo = data.body.recNo
                    this.dataForm.projectPlace = data.body.projectPlace
                    this.dataForm.logDate = this.getCurrentTime();
                }
            });
        },
        uploadScanFile(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadScanFile.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                },
            ).then(res => {
                res = res.data;
                if (res.resultCode === 200) {
                    this.dataForm.filePath = res.body.fileSavePath;
                    // this.dataForm.fileName = this.extractFileName(res.body.fileName);
                    this.dataForm.filePathUrl = res.body.fileUri;
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        dataFormSubmit() {
            // if (this.dataForm.logDate == undefined || this.dataForm.logDate == null || this.dataForm.logDate === '') {
            //     this.$message.error("请设置日期");
            //     return;
            // }

            this.$http({
                url: this.$store.state.httpUrl + "/business/workloginfo/update",
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.$router.push({ name: 'workloginfo' });
                        }
                    });
                }
            });
        },
    }
}
</script>

<style scoped="scoped">
/* .sp-input /deep/ .el-input__inner {
    width: 350px !important;
    text-align: center;
}

.sp-input1 /deep/ .el-input__inner {
    width: 400px !important;
    text-align: center;
}

.sp-input2 /deep/ .el-input__inner {
    width: 100px !important;
    text-align: center;
} */


::v-deep(.el-form-item__content) {
    flex: 1 !important;
    width: 100% !important;
}

::v-deep(.sp-input) {
    width: 97% !important;
    display: block !important;
    font-size: 13px !important;
}

::v-deep(.sp-input .el-input__inner) {
    width: 100% !important;
    box-sizing: border-box !important;
}

/* .shift-input /deep/ .el-input__inner {
    width: 210px !important;
    margin-left: 5px !important;
    text-align: center;
} */

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.upload-demo /deep/ .el-upload-dragger {
    width: 230px;
    height: 115px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 40px;
    margin: -30px 0;
    line-height: 40px;
    padding-top: 45px
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
    line-height: 20px;
}

.border-form .el-row.set_border .col-set_border {
    border-right: solid #dadada 1px;
}

.border-form .el-row .col-set_border1 {
    border-right: solid #dadada 1px;
    border-bottom: solid #dadada 1px;
    border-left: solid #dadada 1px;
    margin-right: -0.5px;
}

.border-form .el-row .col-set_border2 {
    border-right: solid #dadada 1px;
    border-bottom: solid #dadada 1px;
}

.border-form .el-row.set_border {
    border-bottom: solid #dadada 1px;
    border-left: solid #dadada 1px;
    border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
    border-top: solid #dadada 1px;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    white-space: nowrap !important;
    border-right: solid #dadada 1px;
}

.row-form-item {
    margin-top: 10px;
}

.row-form-item .el-form-item {
    margin-right: 0;
}

.shift-item {
    color: #00428e !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    white-space: nowrap !important;
    font-size: 15px;
    height: 40px;
    padding-top: 12px;
}

::v-deep .el-tabs__item.is-active {
    color: #1d1d86;
    background-color: #E1F1FF;
}

::v-deep .el-tabs__item:hover {
    color: #121213;
    background-color: #eceeed;
}

::v-deep .el-tabs--top .el-tabs__item.is-top {
    width: 338px;
    text-align: center;
    border: #cfcfd4 solid 1px;
    /* background-color: white; */
}

::v-deep .el-tabs__item {
    background-color: #e5ebf5;
    font-family: "boschsans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.tabItem {
    font-size: 14px;
    font-weight: bolder;
    margin: 8px 0px 10px 10px;
    background-color: #f9f3f39c;
    /* background-color: grey; */
    height: 32px;
    padding: 9px 0px 5px 5px;
}

.second_title_div {
    margin: 8px 0 10px 30px;
    font-weight: bold;
    font-size: 13px;
}

.el-form--inline .el-form-item {
    margin-right: 0px;
}

::v-deep .note_input .el-input__inner {
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
    width: 1570px;
}

::v-deep .note_input1 .el-textarea__inner {
    padding-right: 50px !important;
    border: 0px;
    resize: none;
    /* border-bottom: 1px solid #dadada; */
}

::v-deep .test_input .el-input__inner {
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
    width: 1570px;
}

.prob_btn {
    margin-left: -60px;
    margin-top: 10px;
    position: absolute;
}

.image {
    width: 90%;
    height: 200px;
    margin-left: 12px;
    display: block;
}

.t-column-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    padding-bottom: 10px;
    height: 50px;
}

.button {
    padding: 0;
    float: right;
}

.item::v-deep .el-form-item__label {
    color: #00428E !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    white-space: nowrap !important;
    border-right: solid #dadada 1px;
    font-size: 13px !important;
}

.set_span {
    display: block;
    font-size: 13px;
    /* 将span转换为块级元素 */
    max-width: 275px;
    /* 设置固定长度 */
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 超出部分隐藏 */
    text-overflow: ellipsis;
    /* 超出部分显示省略号 */
    cursor: default;
    /* 将鼠标光标设置为默认样式 */
}

.titleDiv {
    background-color: #E1F1FF;
    font-size: 15px;
    margin-top: 20px;
    margin-bottom: 12px;
    padding: 10px 0px 10px 10px;
    font-weight: bolder;
}

.subject_blank {
    margin-left: 50px
}

.desc_span {
    padding-top: 2px;
    line-height: 22px;
    border-bottom: solid transparent 1px;
    white-space: pre-line;
    font-size: 13px;
}

.item_row {
    margin-left: 30px;
}
</style>
